import { render, staticRenderFns } from "./EditFolderButton.vue?vue&type=template&id=0f635aa4&"
import script from "./EditFolderButton.vue?vue&type=script&lang=js&"
export * from "./EditFolderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports